import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M24.5,15a5.84,5.84,0,0,0-.73.05l-.11,0a5.15,5.15,0,0,0-.68.15l-1-1.86V9h2a1,1,0,0,0,0-2H19a1,1,0,0,0,0,2h1v3H12V10h1a1,1,0,0,0,0-2H9a1,1,0,0,0,0,2h1v3.36L9,15.22a5.15,5.15,0,0,0-.68-.15l-.11,0A5.84,5.84,0,0,0,7.5,15a5.5,5.5,0,0,0,0,11,5.58,5.58,0,0,0,1-.1h.05a6.11,6.11,0,0,0,.95-.28h0A5.47,5.47,0,0,0,13,21H7.6a1,1,0,0,1-.85-.45.91.91,0,0,1,0-.93L9,15.22a5.25,5.25,0,0,1,1.74.86h0L12,14h5l-2.5,5H12.79a5.48,5.48,0,0,0-2-2.92L9,19h3.78A5.34,5.34,0,0,1,13,20.5a4.07,4.07,0,0,1,0,.5h2.1a1,1,0,0,0,.89-.53L19,14h1l1.16,2.14a5.58,5.58,0,0,1,1.8-.92l2.33,4.4a.93.93,0,0,1-.44,1.28,1,1,0,0,1-1.34-.43l-2.36-4.32h0a5.52,5.52,0,0,0-1.81,2.44l0,.07a4,4,0,0,0-.15.49s0,.08,0,.12-.06.31-.08.47a.77.77,0,0,0,0,.15,4.21,4.21,0,0,0,0,.62A5.5,5.5,0,1,0,24.5,15Z"/><circle cx="7.5" cy="20.5" r="5.5"/><circle cx="24.5" cy="20.5" r="5.5"/>';
export var BikeSVG = function BikeSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
BikeSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(BikeSVG);